import {
  GET_ALL_TRADE_LICENSE_REQUEST,
  GET_ALL_TRADE_LICENSE_SUCCESS,
  GET_ALL_TRADE_LICENSE_FAIL,
  UPDATE_TRADE_LICENSE_REQUEST,
  UPDATE_TRADE_LICENSE_SUCCESS,
  UPDATE_TRADE_LICENSE_FAIL,
  ARCHIVE_TRADE_LICENSE_REQUEST,
  ARCHIVE_TRADE_LICENSE_SUCCESS,
  ARCHIVE_TRADE_LICENSE_FAIL,
  CREATE_TRADE_LICENSE_REQUEST,
  CREATE_TRADE_LICENSE_SUCCESS,
  CREATE_TRADE_LICENSE_FAIL,
  DELETE_EXPIRED_TRADE_LICENSE_REQUEST,
  DELETE_EXPIRED_TRADE_LICENSE_SUCCESS,
  DELETE_EXPIRED_TRADE_LICENSE_FAIL,
  BULK_ASSIGN_TRADE_LICENSE_REQUEST,
  BULK_ASSIGN_TRADE_LICENSE_SUCCESS,
  BULK_ASSIGN_TRADE_LICENSE_FAIL,
  DELETE_TRADE_LICENSE_REQUEST,
  DELETE_TRADE_LICENSE_SUCCESS,
  DELETE_TRADE_LICENSE_FAIL,
} from "../../types/admin/tradeLicenseTypes";

export const getAllTradeLicenseReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_ALL_TRADE_LICENSE_REQUEST:
      return {
        ...state,
        Loading: true,
      };
    case GET_ALL_TRADE_LICENSE_SUCCESS:
      return {
        ...state,
        Loading: false,
        getAllTradeLicenseInfo: payload,
        getAllTradeLicenseError: "",
      };
    case GET_ALL_TRADE_LICENSE_FAIL:
      return {
        ...state,
        Loading: false,
        getAllTradeLicenseInfo: [],
        getAllTradeLicenseError: payload,
      };
    default:
      return state;
  }
};

export const updateTradeLicenseReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_TRADE_LICENSE_REQUEST:
      return {
        ...state,
        updateTradeLicenseLoading: true,
      };
    case UPDATE_TRADE_LICENSE_SUCCESS:
      return {
        ...state,
        updateTradeLicenseLoading: false,
        updateTradeLicenseInfo: payload,
        updateTradeLicenseError: "",
      };
    case UPDATE_TRADE_LICENSE_FAIL:
      return {
        ...state,
        updateTradeLicenseLoading: false,
        updateTradeLicenseInfo: [],
        updateTradeLicenseError: payload,
      };
    default:
      return state;
  }
};

export const archiveTradeLicenseReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case ARCHIVE_TRADE_LICENSE_REQUEST:
      return {
        ...state,
        Loading: true,
      };
    case ARCHIVE_TRADE_LICENSE_SUCCESS:
      return {
        ...state,
        Loading: false,
        archiveTradeLicenseInfo: payload,
        archiveTradeLicenseError: "",
      };
    case ARCHIVE_TRADE_LICENSE_FAIL:
      return {
        ...state,
        Loading: false,
        archiveTradeLicenseInfo: [],
        archiveTradeLicenseError: payload,
      };
    default:
      return state;
  }
};

export const createTradeLicenseReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case CREATE_TRADE_LICENSE_REQUEST:
      return {
        ...state,
        createTradeLicenseLoading: true,
      };
    case CREATE_TRADE_LICENSE_SUCCESS:
      return {
        ...state,
        createTradeLicenseLoading: false,
        createTradeLicenseInfo: payload,
        createTradeLicenseError: "",
      };
    case CREATE_TRADE_LICENSE_FAIL:
      return {
        ...state,
        createTradeLicenseLoading: false,
        createTradeLicenseInfo: [],
        createTradeLicenseError: payload,
      };
    default:
      return state;
  }
};

export const deleteExpiredTradeLicenseReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case DELETE_EXPIRED_TRADE_LICENSE_REQUEST:
      return {
        ...state,
        Loading: true,
      };
    case DELETE_EXPIRED_TRADE_LICENSE_SUCCESS:
      return {
        ...state,
        Loading: false,
        deleteExpiredTradeLicenseInfo: payload,
        deleteExpiredTradeLicenseError: "",
      };
    case DELETE_EXPIRED_TRADE_LICENSE_FAIL:
      return {
        ...state,
        Loading: false,
        deleteExpiredTradeLicenseInfo: [],
        deleteExpiredTradeLicenseError: payload,
      };
    default:
      return state;
  }
};

export const bulkAssignTradeLicenseReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case BULK_ASSIGN_TRADE_LICENSE_REQUEST:
      return {
        ...state,
        bulkAssignTradeLicenseLoading: true,
      };
    case BULK_ASSIGN_TRADE_LICENSE_SUCCESS:
      return {
        ...state,
        bulkAssignTradeLicenseLoading: false,
        bulkAssignTradeLicenseInfo: payload,
        bulkAssignTradeLicenseError: "",
      };
    case BULK_ASSIGN_TRADE_LICENSE_FAIL:
      return {
        ...state,
        bulkAssignTradeLicenseLoading: false,
        bulkAssignTradeLicenseInfo: [],
        bulkAssignTradeLicenseError: payload,
      };
    default:
      return state;
  }
};

export const deleteTradeLicenseReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case DELETE_TRADE_LICENSE_REQUEST:
      return {
        ...state,
        deleteTradeLicenseLoading: true,
      };
    case DELETE_TRADE_LICENSE_SUCCESS:
      return {
        ...state,
        deleteTradeLicenseLoading: false,
        deleteTradeLicenseInfo: payload,
        deleteTradeLicenseError: "",
      };
    case DELETE_TRADE_LICENSE_FAIL:
      return {
        ...state,
        deleteTradeLicenseLoading: false,
        deleteTradeLicenseInfo: [],
        deleteTradeLicenseError: payload,
      };
    default:
      return state;
  }
};
